import {IPropertyDto} from "../../../../common/apis/CommonTypes";

export class PropertyComparator {

    static compare(property1: IPropertyDto, property2: IPropertyDto): number {
        const name1 = property1.definition.name.toLowerCase();
        const name2 = property2.definition.name.toLowerCase();
        if (name1 < name2) {
            return -1;
        } else if (name1 > name2) {
            return 1;
        } else {
            return 0;
        }
    }
}